module.exports = __webpack_public_path__ + "static/media/specific-multiple-select.74ca78fa.gif";